import(/* webpackMode: "eager" */ "/var/www/restroagent/src/app/login/page.tsx");
